// SPDX-FileCopyrightText: © 2019 Jaro Habiger <jarohabiger@googlemail.com>
// SPDX-License-Identifier: AGPL-3.0-only

export const NCTRL_BASE_PATH = './nctrl_mountpoint/';
